import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components/macro";
import { AppState } from "State";

export default function OverlayBackdrop() {
  const [{ overlays }] = useContext(AppState);

  const [showBackdrop, setShowBackdrop] = useState(false);

  useEffect(() => {
    setShowBackdrop(
      overlays.length > 0 && overlays.find((ol) => ol.hideBackground)
        ? true
        : false
    );
  }, [overlays, overlays.length]);

  return (
    <Backdrop className={"OverlayBackdrop " + (showBackdrop ? "show" : "")} />
  );
}

const Backdrop = styled.div`
  position: fixed;
  z-index: 8000;
  top: 0;
  left: 0;

  &::before {
    content: "";
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: -1;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.4s, visibility 0.4s;
  }
  &.show::before {
    opacity: 1;
    visibility: visible;
  }
`;
